import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { useCustomerNotifications } from "context/CustomerNotificationsContext";
import { statusOptions } from "constants/CodConstants";
import { useHookFormMask, withMask } from "use-mask-input";
import MDSelect from "components/MDSelect";
import { SearchProvider } from "context/SearchContext";
import SearchContactByCustomer from "components/SearchContactByCustomer";
import { useSearch } from "context/SearchContext";

function CustomersNotificationsForm({ setShowForm }) {
  const [dataCustomer, setDataCustomer] = useState({});
  const [customerPhone, setCustomerPhone] = useState();
  const [disable, setDisable] = useState(true);
  const {
    storeCustomerNotification,
    updateCustomerNotification,
    editCustomerNotification,
    setEditCustomerNotification,
    loading,
    setLoading,
  } = useCustomerNotifications();

  const { searchCustomer, response, setResponse } = useSearch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm();

  const search_customer = watch("search_customer");
  const status = watch("status");

  const registerWithMask = useHookFormMask(register);

  const onHandleSubmit = (data) => {
    data["customer_id"] = dataCustomer.id;
    data["customer_phone_id"] = customerPhone.id;
    if (Object.keys(editCustomerNotification).length != 0) {
      setShowForm(false);
      return updateCustomerNotification(data);
    }
    setEditCustomerNotification({});
    storeCustomerNotification(data);
    setShowForm(false);
  };

  const onCancelEditCustomer = () => {
    setEditCustomerNotification({});
    reset({
      note: "",
      notify_at: "",
      status: "",
      notified: "",
    });
  };

  useEffect(() => {
    if (search_customer?.length >= 3) {
      searchCustomer(search_customer);
    }
  }, [search_customer]);

  useEffect(() => {
    reset(editCustomerNotification);
  }, [editCustomerNotification]);

  return (
    <MDBox sx={{ p: 2 }}>
      <Grid
        container
        spacing={2}
        component="form"
        onSubmit={handleSubmit(onHandleSubmit)}
        role="form"
      >
        <SearchProvider>
          <Grid container sx={{ p: 2 }}>
            <SearchContactByCustomer
              dataCustomer={dataCustomer}
              setDataCustomer={setDataCustomer}
              customerPhone={customerPhone}
              setCustomerPhone={setCustomerPhone}
            />
          </Grid>
        </SearchProvider>
        <Grid item xs={4}>
          <MDInput
            variant="outlined"
            required
            fullWidth
            id="note"
            label="Nota"
            name="note"
            {...register("note")}
            // value={formData.name}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={4}>
          <MDInput
            variant="outlined"
            fullWidth
            id="notify_at"
            label="Notificado em:"
            name="notify_at"
            {...registerWithMask("notify_at", "datetime", {
              inputFormat: "yyyy-mm-dd",
            })}
          />
        </Grid>
        <Grid item xs={4}>
          <MDSelect
            select
            variant="outlined"
            fullWidth
            id="status"
            label="Status"
            placeholder="Status"
            name="status"
            value={status}
            options={statusOptions}
            onChange={(e) => setValue("status", e.target.value)}
            {...register("status")}
          />
        </Grid>
        <Grid item xs={12} spacing={2}>
          {Object.keys(editCustomerNotification).length == 0 ? (
            <MDButton
              type="submit"
              disabled={loading}
              fullWidth
              variant="contained"
              color="primary"
            >
              Enviar
            </MDButton>
          ) : (
            <>
              <MDButton type="submit" variant="contained" color="primary">
                Editar
              </MDButton>
              <MDButton variant="contained" color="primary" onClick={onCancelEditCustomer}>
                Cancelar
              </MDButton>
            </>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

CustomersNotificationsForm.propTypes = {
  setShowForm: PropTypes.func,
};

export default CustomersNotificationsForm;
